import React from "react";

const SOCIALS = {
  instagram: "https://www.instagram.com/harmoniaportal/",
  linkedin: "https://www.linkedin.com/in/hadil-el-baba-a231a912a/",
  email: "mailto:harmoniaportal.5@gmail.com",
};

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-bone border-t border-stone/30">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <h4 className="font-serif text-3xl text-charcoal italic">Hadil El-Baba</h4>
          <p className="text-xs uppercase tracking-[0.22em] text-ink mt-2">
            Architect · Systems Thinker · Facilitator
          </p>
          <p className="text-sm text-ink/80 mt-6 leading-relaxed max-w-sm">
            Translating observations, stories and complex ideas into frameworks, experiences and communities.
          </p>
        </div>

        <div>
          <p className="text-[10px] uppercase tracking-[0.3em] text-stone mb-5">Elsewhere</p>
          <ul className="space-y-3 text-sm text-charcoal">
            <li>
              <a data-testid="footer-instagram" className="link-underline" href={SOCIALS.instagram} target="_blank" rel="noreferrer">
                Instagram
              </a>
            </li>
            <li>
              <a data-testid="footer-linkedin" className="link-underline" href={SOCIALS.linkedin} target="_blank" rel="noreferrer">
                LinkedIn
              </a>
            </li>
            <li>
              <a data-testid="footer-email" className="link-underline" href={SOCIALS.email}>
                Email
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-[10px] uppercase tracking-[0.3em] text-stone mb-5">Begin</p>
          <a
            data-testid="footer-calendly"
            href="https://calendly.com/harmoniaportal-5"
            target="_blank"
            rel="noreferrer"
            className="inline-block text-sm font-serif italic text-charcoal link-underline"
          >
            Schedule an alignment call →
          </a>
        </div>
      </div>

      <div className="border-t border-stone/30">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[10px] uppercase tracking-[0.3em] text-stone">
            © {new Date().getFullYear()} Hadil El-Baba — Harmonia Portal
          </p>
          <p className="text-[10px] uppercase tracking-[0.3em] text-stone italic font-serif">
            built slowly, with care
          </p>
        </div>
      </div>
    </footer>
  );
};

export const SOCIAL_LINKS = SOCIALS;
export default Footer;
